export const QUERY_KEYS = {
  GET_DESTINATIONS: 'GET_DESTINATIONS',
  GET_TARGETS: 'GET_TARGETS',
};
